import React from "react";
import Link from "next/link";
import Image from "next/image";
import finalCtaBg from "@/assets/images/final_cta_bg.png";
import { CALENDLY_URL } from "@/common/site.config";

function FinalCta({
  title,
  descriptionPrimary,
  descriptionSecondary,
  linkText,
  url = CALENDLY_URL,
}) {
  const isExternal = /^https?:\/\//i.test(url);

  return (
    <section className="theme-band-dark relative py-16 md:py-20">
      <Image
        src={finalCtaBg}
        alt=""
        fill
        quality={90}
        className="z-[-1] object-cover opacity-90"
      />
      <div className="container relative z-10 max-w-7xl">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <div className="max-w-2xl">
            <h2 className="text-2xl font-bold tracking-tight text-white md:text-3xl lg:text-4xl">
              {title}
            </h2>
            {descriptionPrimary ? (
              <p className="mt-4 text-base leading-relaxed text-slate-300">
                {descriptionPrimary}
              </p>
            ) : null}
            {descriptionSecondary ? (
              <p className="mt-3 text-base leading-relaxed text-slate-400">
                {descriptionSecondary}
              </p>
            ) : null}
          </div>

          <Link
            href={url}
            {...(isExternal
              ? { target: "_blank", rel: "noopener noreferrer" }
              : {})}
            className="landing-btn-primary shrink-0"
          >
            {linkText}
          </Link>
        </div>
      </div>
    </section>
  );
}

export default FinalCta;
